import React from "react";
import "../Biography.css";  // <-- import the shared biography styles

const MikaoUsui = () => {
  return (
    <section className="biography-section">
      
      
       {/* Biography Text */}
        <div className="bio-text">
  <img 
    src={`${process.env.PUBLIC_URL}/images/Dr_Mikao_Usui.webp`} 
    alt="Dr_Mikao_Usui"
    className="bio-inline-photo"
  />
  <h2>Biography of Dr. Mikao Usui (1865–1926)</h2>
  <h3 className="subtitle">Founder of the Usui System of Reiki Healing</h3>

  {/* Early Life */}
  <h3>Early Life and Background</h3>   

        <p>
          Dr. Mikao Usui (often respectfully called <strong>Usui Sensei</strong>)
          was born on <strong>15 August 1865</strong> in the village of Taniai,
          located in the Gifu Prefecture of Japan. His birth name was
          <strong> Usui Mikao</strong>, and he grew up in a family that followed
          the <strong>Tendai Buddhist tradition</strong>, one of the oldest schools
          of Japanese Buddhism. From a young age, Usui displayed curiosity,
          discipline, and a deep interest in spiritual matters.
        </p>
        <p>
          Japan during the late 19th century was experiencing rapid modernization
          under the Meiji Restoration. Western influences in science, medicine,
          and philosophy were entering Japanese society, blending with traditional
          Buddhist and Shinto practices. Young Mikao grew up during this transformative
          era, exposed to both ancient Eastern wisdom and the curiosity surrounding
          Western knowledge.
        </p>

        <h3>Education and Interests</h3>
        <p>
          Usui was a dedicated student with a wide range of interests. He was
          particularly drawn to:
        </p>
        <ul>
          <li>
            <strong>Buddhism and Spirituality</strong> – As a child in a Buddhist
            family, he studied scripture, meditation, and spiritual practices.
          </li>
          <li>
            <strong>Martial Arts</strong> – Usui was also known to have trained in
            martial arts, which helped him develop discipline and focus.
          </li>
          <li>
            <strong>Medicine and Healing</strong> – He had a lifelong interest in
            healing techniques, both Eastern (traditional Chinese medicine, herbal
            remedies, energy practices) and Western (modern anatomy and physiology).
          </li>
          <li>
            <strong>Languages and Literature</strong> – Usui was said to be
            well-educated, with knowledge of Sanskrit and Chinese, which later
            helped him in his research into ancient healing texts.
          </li>
        </ul>
        <p>
          These broad interests formed the foundation for his later discoveries, as
          he searched for a method of healing that addressed not just the body, but
          also the mind and spirit.
        </p>

        <h3>The Spiritual Quest</h3>
        <p>
          Throughout his life, Usui was deeply concerned with one central question:
        </p>
        <p>
          <strong>
            “Is there a universal method of healing that can help people everywhere,
            regardless of their faith, culture, or background?”
          </strong>
        </p>
        <p>
          This quest led him to study many religious texts and spiritual traditions.
          He explored the teachings of Buddhism, Taoism, Shinto, and even Christian
          writings. Some accounts suggest he also studied ancient Indian scriptures,
          which describe concepts of <em>prana</em> (life energy) similar to <em>ki</em>{" "}
          in Japanese tradition.
        </p>
        <p>
          Despite his dedication, Usui often felt that he had not yet discovered the
          true key to a healing practice that was both universal and accessible. He
          believed that such a system must be rooted in spiritual wisdom but also
          practical enough to help ordinary people in their everyday lives.
        </p>

        <h3>Mount Kurama and the Great Awakening</h3>
        <p>
          In <strong>1922</strong>, Usui decided to undertake a period of fasting
          and meditation on <strong>Mount Kurama</strong>, a sacred mountain near
          Kyoto, long associated with spiritual practice in Japanese history.
        </p>
        <p>
          According to traditional accounts, Usui went into a{" "}
          <strong>21-day meditation retreat</strong>, practicing fasting, chanting,
          and prayer. On the final day, he experienced a profound{" "}
          <strong>spiritual awakening</strong>. A great light or energy is said to
          have entered through the top of his head, filling his body and
          consciousness with immense power and understanding.
        </p>
        <p>
          In that moment, Usui realized he had received the gift of{" "}
          <strong>Reiki</strong> — a universal life energy that could be channeled
          through the hands for healing. This experience not only transformed his
          personal understanding of life energy but also revealed a practical
          method for transmitting it to others.
        </p>

        <h3>Founding of Reiki</h3>
        <p>
          After his awakening, Usui began to practice and share this new form of
          healing. In <strong>April 1922</strong>, he founded the{" "}
          <strong>Usui Reiki Ryoho Gakkai</strong> (Usui Reiki Healing Society) in
          Tokyo. The purpose of the organization was to:
        </p>
        <ul>
          <li>Teach the principles of Reiki to students.</li>
          <li>Offer healing sessions to the public.</li>
          <li>
            Promote Reiki as a holistic system of natural and spiritual healing.
          </li>
        </ul>
        <p>
          Usui emphasized that Reiki was not just a healing technique but also a way
          of living in harmony with universal principles.
        </p>

        <h3>The Five Reiki Principles</h3>
        <p>
          One of Usui’s lasting contributions was the formulation of the{" "}
          <strong>Five Reiki Principles</strong>, which he encouraged his students
          to recite daily:
        </p>
        <ul>
          <li>Just for today, do not be angry.</li>
          <li>Just for today, do not worry.</li>
          <li>Just for today, be grateful.</li>
          <li>Just for today, do your work honestly.</li>
          <li>Just for today, be kind to every living thing.</li>
        </ul>

        <h3>Spreading Reiki in Japan</h3>
        <p>
          Reiki quickly gained popularity in Japan. Usui treated many patients and
          trained a growing number of students. By <strong>1925</strong>, only three
          years after founding his society, he had taught more than{" "}
          <strong>2,000 students</strong> and initiated around{" "}
          <strong>20 Reiki Masters</strong>.
        </p>
        <p>
          Reiki was especially valued in post-war Japan, a time when people were
          struggling with illness, poverty, and emotional trauma. Usui’s method
          offered hope, comfort, and healing at a time of great need.
        </p>

        <h3>Final Years and Passing</h3>
        <p>
          In <strong>1925</strong>, Usui moved to Fukuyama in Hiroshima Prefecture
          to continue his work. He traveled extensively throughout Japan, teaching
          and healing wherever he went.
        </p>
        <p>
          On <strong>9 March 1926</strong>, at the age of 60, Dr. Mikao Usui passed
          away from a stroke while teaching in Fukuyama. His death was sudden, but
          his legacy continued through his students, particularly{" "}
          <strong>Chujiro Hayashi</strong>, who later passed Reiki on to{" "}
          <strong>Hawayo Takata</strong>, the Japanese-American woman responsible
          for introducing Reiki to the Western world.
        </p>

        <h3>Legacy of Dr. Usui</h3>
        <p>
          Dr. Usui’s contribution to the world cannot be overstated. He left behind
          not just a healing technique but a spiritual path. Today, Reiki is
          practiced in over <strong>100 countries</strong> and is recognized as a
          complementary therapy in many hospitals and wellness centers.
        </p>
        <ul>
          <li>
            <strong>The Practice</strong> – Reiki healing continues to help millions
            reduce stress, promote relaxation, and support recovery.
          </li>
          <li>
            <strong>The Teachings</strong> – His Five Principles provide timeless
            guidance for living a balanced, mindful, and compassionate life.
          </li>
          <li>
            <strong>The Lineage</strong> – His students and their successors have
            preserved and spread Reiki worldwide.
          </li>
        </ul>

        <h3>Conclusion</h3>
        <p>
          Dr. Mikao Usui’s life was a journey of spiritual seeking, discovery, and
          service. From his early interests in healing and spirituality, through his
          awakening on Mount Kurama, to the founding of the Usui Reiki Ryoho Gakkai,
          his mission was always the same:
        </p>
        <p>
          <strong>
            To offer a universal method of healing that could bring peace, balance,
            and harmony to all people.
          </strong>
        </p>
        <p>
          Nearly a century after his passing, Reiki remains a powerful testimony to
          his vision — that healing is not just about the body, but about nurturing
          the whole person: body, mind, and spirit.
        </p>
      </div>
    </section>
  );
};

export default MikaoUsui;
